var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 38,
    viewBox: "0 0 38 38",
    width: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19 37c9.9411 0 18-8.0589 18-18 0-9.94113-8.0589-18-18-18-9.94113 0-18 8.05887-18 18 0 9.9411 8.05887 18 18 18z",
    fill: "#fff",
    fillOpacity: 0.950861,
    stroke: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 17.7432 4.3212-4.3213.7071-.7071 1.2571 1.2571-.7071.7071-4.3212 4.3212 4.3212 4.3212.7071.7071-1.2571 1.2571-.7071-.7071-4.3212-4.3212-4.3212 4.3212-.7071.7071-1.2571-1.2571.7071-.7071 4.3212-4.3212-4.3212-4.3212-.7071-.7071 1.2571-1.2571.7071.7071z",
    fill: "#5e6064"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloser);
export default __webpack_public_path__ + "static/media/closer.51b6e042e66c38a58823ba5477d9bcf9.svg";
export { ForwardRef as ReactComponent };